export const cssModelFactory = require('!carmi/loader?compiler=simple!../carmi/cssModule.carmi')
export const ooiCssModelFactory = require('!carmi/loader?compiler=simple!../carmi/ooiCss.carmi')
